module.exports = __webpack_public_path__ + "img/cd-640.8e52a6c4.jpg";